import { Box, Field, FieldControl, FieldLabel } from "@prismicio/editor-ui"
import { useId } from "react"

import { FieldTextInput } from "../../FieldTextInput"

interface ImageAltControlProps {
  readOnly?: boolean
  altText: string
  selected?: boolean
  onValueChange: (value: string) => void
}

export function ImageAltControl(props: ImageAltControlProps) {
  const { readOnly, altText, selected, onValueChange } = props

  const id = useId()

  return (
    <Field selected={selected}>
      <FieldLabel htmlFor={id}>Alt text</FieldLabel>
      <FieldControl>
        <Box flexGrow={1} height={40}>
          <FieldTextInput
            id={id}
            placeholder="Short description for the visually impaired"
            readOnly={readOnly}
            value={altText}
            padding={{ input: { inline: 12 } }}
            onValueChange={onValueChange}
          />
        </Box>
      </FieldControl>
    </Field>
  )
}
